<template>
  <div class="dynamic-field-container" style="margin-top: 10px">
    <label>{{ field.label }}</label>
    <ckeditor :editor="editor" :ref="field.key" v-model="proxyValue" :config="ckEditorConfig" :disabled="isTaskFieldDisabled"></ckeditor>
    <small class="text-danger" v-show="errors.has('fieldName')">
      {{ getError('fieldName') }}
    </small>
  </div>
</template>

<script>
  import {generateDynamicFieldValidation, canEditTaskField} from 'src/utilities/utils'
  import Constants from 'src/utilities/constants'
  import CKEditor from '@ckeditor/ckeditor5-vue'
  import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor'
  import ckEditorConfig from 'src/utilities/ckeditor'

  export default {
    name: 'HTML',
    inject: ['$validator'],
    props: ['field', 'value', 'commit', 'task', 'disabled'],
    fieldName: 'temp',
    components: {
      ckeditor: CKEditor.component
    },
    computed: {
      fieldValidationRules() {
        // expressions override other validation logic
        if (this.field.expression) {
          this.fieldValidation = function(str) {
            return eval(str).apply(this)
          }.call(this, this.field.expression)
        }
        return this.fieldValidation
      },
      proxyValue: {
        get() {
          return this.value ? this.value : '' //ckeditor can't handle null values
        },
        set(newValue) {
          this.$store.commit(this.commit, { key: this.field.key, value: newValue })
        }
      },
      isTaskFieldDisabled() {
        if (this.disabled) {
          return true
        }
        return !canEditTaskField(this)
      }
    },
    data() {
      return {
        editor: ClassicEditor,
        ckEditorConfig,
        fieldValidation: {},
        constants: Constants,
        statusOnLoad: null
      }
    },
    methods: {
      loadData() {
        this.$refs[this.field.key].update(this.value)
      },
      getError(fieldName) {
        return this.errors.first(fieldName)
      }
    },
    beforeMount() {
      generateDynamicFieldValidation(this)
      this.statusOnLoad = JSON.parse(JSON.stringify(this.task.status))
    }
  }
</script>

<style scoped>
  label {
    display: block;
  }
  .dynamic-field-container {
    margin-bottom: 10px;
    width: 99%;
  }
</style>
